import { usePermissions } from "components/context/permissionsContext";

export const useContactPermission = () => {
  const { userPermissions } = usePermissions();

  const hasContactSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Contact" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasContactGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Contact" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasContactDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Contact" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  const ContactPermissionProps = {
    hasContactSavePermission,
    hasContactGetPermission,
    hasContactDeletePermission,
  };

  return {
    ContactPermissionProps,
  };
};
